@if (input().subtitle) {
    <div class="subtitle medium-margin-bottom">
        {{ input().subtitle }}
    </div>
}

<form>
    <ui-form-field [label]="'POPOVERS.CONFIRM_ACTION.TYPE_CONFIRM_TEXT' | translate: { textToType: input().textToType }">
        <input advizeoInput [formControl]="control" [required]="true" />
        @if (control.errors?.wrongValidationMessage) {
            <ui-form-error>
                {{ 'POPOVERS.CONFIRM_ACTION.WRONG_TYPING_ERROR' | translate: { textToType: input().textToType } }}
            </ui-form-error>
        }
    </ui-form-field>
</form>
